module.exports = __webpack_public_path__ + "static/img/13.95952cae.png";